import { styled } from "@mui/material/styles";

const getFontStyles = () => ({
  fontFamily: "Inter",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "1rem",
  lineHeight: "24px",
});

export const DescriptionWrapper = styled("div")(() => ({
  display: "flex",
  gap: 12,
  alignItems: "flex-start",
  justifyContent: "flex-start",
  flexDirection: "column",
}));

export const Description = styled("span")(() => ({
  ...getFontStyles(),
}));

export const Warning = styled("span")(() => ({
  ...getFontStyles(),
  color: "#F04438",
  fontStyle: "italic",
}));
